export const FOLDERS = {
    DRIVE_PAGE_HEADER: "drive-page-header",
    DIALOG: {
        TITLE: "dialog-title",
        CONTAINER: "dialog-container",
        INPUT: "name-input",
        ERROR: "error-text",
        CANCEL_BTN: "cancel-btn",
        CUSTOM_LEFT_BTN: "custom-left-btn",
        SAVE_BTN: "save-btn",
        OK_BTN: "ok-btn",
    },
    NEW_BTN: "new-btn",
    NEW_FOLDER: "new-folder-btn",
    NEW_ASSORTMENT: "new-assortment-btn",
    NEW_WHITEBOARD: "new-whiteboard-btn",
    NEW_ASSORTMENT_ROLLUP: "new-assortment-rollup-btn",
    BREADCRUMB: "wayfinding-breadcrumb",
    MAIN_CONTAINER: "main-container",
    ITEMS_CONTAINER: "items-container",
    SELECTION_MAIN_CONTAINER: "selection-main-container",
    SELECTION_ITEMS_CONTAINER: "selection-items-container",
    SELECT_MERCHANT: "select-merchant",

    TOOLBAR: {
        MANAGE_ACCESS_BTN: "manage-access-btn",
        DELETE_BTN: "delete-btn",
        DELETE_ITEMS_BTN: "delete-items-btn",
        RENAME_BTN: "rename-btn",
        ROLLUP_BTN: "rollup-btn",
        KABOB_BTN: "kabob-btn",
        VIEW_ROLLUP_BTN: "view-rollup-btn",
        EDIT_ROLLUP_BTN: "edit-rollup-btn",
        MOVE_BTN: "move-btn",
        CREATE_SHORTCUT_BTN: "create-shortcut-btn",
        RESTORE_BTN: "restore-btn",
        CLEAR_SELECTION_BTN: "clear-selection-btn",
        ADD_TO_STARRED: "add-to-starred",
        REMOVED_FROM_STARRED: "remove-from-starred",
        EXPORT_WHITEBOARDS_BTN: "export-whiteboards-btn",
    },

    ASSET_ROW: {
        ROW: "asset-row",
        LINK: "asset-row-link",
        NAME: "asset-row-name",
        TYPE: "asset-row-type",
        ACTION_BTN: "asset-actions-btn",
        DIRECT_MANAGE_ACCESS: "asset-row-direct-manage-access-btn",
        MANAGE_ACCESS: "asset-row-manage-access-btn",
        DELETE: "asset-row-delete-btn",
        RENAME: "asset-row-rename-btn",
        ROLLUP: "asset-row-rollup-btn",
        MOVE: "asset-row-move-btn",
        COPY_LINK: "asset-row-copy-link-btn",
        CREATE_SHORTCUT: "asset-row-create-shortcut-btn",
        EDIT_ROLLUP: "asset-row-edit-rollup-btn",
        RESTORE: "asset-row-restore-btn",
        ADD_TO_STARRED: "asset-row-add-to-starred-btn",
        REMOVE_FROM_STARRED: "asset-row-remove-from-starred-btn",
        COPY_ASSORTMENT: "asset-row-copy-assortment-btn",
        MERCHANT: "asset-row-merchant",
    },

    MANAGE_ACCESS: {
        PANEL: "manage-access-panel",
        ADD_ACCESS_BTN: "add-access-btn",
    },
    ASSORTMENT: {
        GRANT_ACCESS: {
            PIVOT: "pivot",
            BRAND_TAB: "assortment__grant-access__brand-tab",
            BUYER_TAB: "assortment__grant-access__buyer-tab",
            INTERNALLY_TAB: "assortment__grant-access__internally-tab",
            PERSONA_LIST: "persoan-list",
            MANAGE_ACCESS_FORM: "manage-access-form",
            DELETE_PERMISSION_DIALOG: "delete-permission-dialog",
            ERROR_MESSAGE_BAR: "error-message-bar",
        },
    },
    GRANT_ACCESS: {
        CONTAINER: "grant-access-container",
        RECIPIENT_DROPDOWN: "recipient-dropdown",
        PERMISSIONS_DROPDOWN: "permissions-dropdown",
        GRANT_BTN: "grant-access-btn",
        CLOSE_BTN: "close_btn",
        PERSONA_LIST: "persoan-list",
        DELETE_PERMISSION_DIALOG: "delete-permission-dialog",
        COMMAND_BAR: "command-bar",
        MANAGE_ACCESS_FORM: "manage-access-form",
        MANAGE_ACCESS_PICKER: "manage-access-picker",
        MANAGE_ACCESS_FORM_WRAPPER: "manage-access-form-wrapper",
        DIALOG: "dialog",
        DIALOG_TITLE: "dialog-title",
        PIVOT: "pivot",
        ERROR_MESSAGE_BAR: "error-message-bar",
        NORMAL_PEOPLE_PICKER: "normal-people-picker",
        NORMAL_PEOPLE_PICKER_INPUT: "normal-people-picker-input",
        NORMAL_PEOPLE_PICKER_SUGGESTIONS_CONTAINER: "normal-people-picker-suggestions-container",
        NORMAL_PEOPLE_PICKER_SUGGESTIONS_OPTION: "normal-people-picker-suggestions-option",
        PERSONA_ITEM: "persona-item",
        PERSONA_ITEM_DROPDOWN: "persona-item-dropdown",
        PICKER_PERSONA_ITEM: "picker-persona-item",
    },
    SIDEBAR: {
        MERCHANT_DROPDOWN: "switch-merchant-dropdown",
        MERCHANT_DRIVE: "merchant-drive-option",
        MERCHANT_DRIVE_TRASH: "merchant-drive-trash-option",
        MY_DRIVE: "my-drive-option",
        MY_DRIVE_TRASH: "my-drive-trash-option",
        SHARED_WITH_ME: "shared-with-me-option",
        STARRED: "starred-option",
    },
    MULTI_SELECT: {
        DROPDOWN: "multi-select-dropdown",
        TITLE: "multi-select-title",
        SEARCH_AREA: "multi-select-search-area",
    },
    CREATE_ASSORTMENT_DIALOG: {
        CONTAINER: "create-assortment-container",
        ASSORTMENT_TYPE: "create-assortment-type",
        TYPES: {
            INTERNAL: "internal-assortment",
            EXTERNAL: "external-assortment",
        },
        ALLOCATION_DIMENSIONS: "create-assortment-dimensions",
        BRAND_PICKER: "create-assortment-brand-picker",
        ASSORTMENT_TEMPLATE_DROPDOWN: "assortment-template-dropdown",
        ASSORTMENT_MERCHANT_DROPDOWN: "assortment-merchant-dropdown",
        MESSAGE_ERROR: "create-assortment-message-error",
    },
    CREATE_ROLLUP_ASSORTMENT_DIALOG: {
        CONTAINER: "create-rollup-assortment-container",
        NAME: "create-rollup-assortment-name",
        DESTINATION: "create-rollup-assortment-destination",
        ASSORTMENT_PICKER: "create-rollup-assortment-collection-picker",
        MESSAGE_ERROR: "create-rollup-assortment-message-error",
        ASSORTMENT_TAG: "create-rollup-assortment-tag",
    },
    EXPORT_WHITEBOARDS_DIALOG: {
        WHITEBOARD_PICKER: "export-whiteboards-collection-picker",
    },
    TAG_PICKER: {
        LOADING: "tag-picker-loading",
    },
    DRIVE_WORKSPACE: {
        TITLE: "MerchantsContainer_Title",
        MERCHANT_ROW: "drive-workspace-merchant-row",
        CANCEL_BTN: "drive-workspace-cancel-btn",
        CONTINUE_BTN: "drive-workspace-continue-btn",
    },
    ITEM_SELECTOR: "item-selector",
    CHOOSE_DESTINATION_TEXT: "choose-destination-text",
    CHOOSE_DESTINATION_BTN: "choose-destination-btn",
    ITEM_PICKER: {
        SELECT_ALL: "item-picker-select-all-cbx",
        DONE_BTN: "item-picker-done-btn",
    },
    BULK_MOVE_NOTIFIER: "bulk-move-notifier",
    WHITEBOARD_SELECTOR: "whiteboard-selector",
    OPEN_ROLLUP_DIALOG: {
        HELPER_TEXT: "helper_text",
        PROGRESS_INDICATOR: "progress_indicator",
        COLLECTION_NOT_FOUND: "collection_not_found",
        AUTHORIZATION_ERROR: "authorization_error",
        SERVER_ROLLUP_DISABLED: "server_rollup_disabled",
    },
    EMPTY_LIST_VIEW_BTN: "empty-list-view-btn",
};

export const FOLDER_IDENTIFIERS = {
    DIALOG: {
        MOVE_CONTAINER_ID: "move-confirmation-conatiner",
        RESTORE_CONTAINER_ID: "restore-alert-conatiner",
        DELETE_CONTAINER_ID: "delete-confirmation-conatiner",
        OPEN_ROLLUP_CONTAINER_ID: "open-rollup-conatiner",
    },
};
